import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import defaultPrompts from '../../data/default-prompts.json';
import { toast } from 'sonner';
import { useChat } from '../../context/ChatContext';
import ChatInput from '../../components/chat/ChatInput';
import DeleteChatModal from '../../components/ui/ChatDeleteModal';

export default function ChatWelcome() {
  const navigate = useNavigate();
  const [userMessage, setUserMessage] = useState('');
  const { createChat, deleteChatId } = useChat();

  const handleChatStart = async () => {
    const message = userMessage.trim();
    if (!message) return;

    try {
      const { chat_id } = await createChat(message);
      setUserMessage('');
      // Navigate to the new chat page
      navigate(`/chat/${chat_id}`, { state: { trimmedMessage: message } });
    } catch (error) {
      console.error('Failed to start chat:', error.message);
      toast.error('Unable to start chat. Please try again.');
    }
  };

  return (
    <>
      <div className="flex flex-col items-center gap-12 mt-4 mb-8 lg:my-0 text-center lg:h-full md:pt-8">
        <div className="flex flex-col gap-4 max-w-[600px]">
          <h1 className="text-[28px] text-[#002231]">
            Hi! I'm Twiggy, Red Oak Realty's AI assistant
          </h1>
          <h3 className="text-[#002231] text-lg">
            Need to look up a process, contact, or detail from the Red Oak
            playbook? <br /> Just let me know how I can help.
          </h3>
        </div>

        <div className="w-full max-w-3xl">
          <ChatInput
            message={userMessage}
            setMessage={setUserMessage}
            handleSend={handleChatStart}
          />

          <div className="grid grid-cols-1 sm:grid-cols-2 grid-rows-3 gap-4 mt-8">
            {defaultPrompts.map((prompt, i) => (
              <div
                key={i}
                className="p-4 text-base text-[#4E5151] cursor-pointer transition-all text-left bg-white border border-[#F0F0F0] rounded-lg hover:bg-gray-50"
                style={{ boxShadow: '0px 4px 16px 0px #F5F5F5' }}
                onClick={() => setUserMessage(prompt.message)}
              >
                {prompt.message}
              </div>
            ))}
          </div>
        </div>
      </div>
      {deleteChatId && <DeleteChatModal />}
    </>
  );
}
